<template>
    <AuthLayout :imageSrc="currentImage">
        <div class="restPWRow flex justify-content-center align-items-center w-full">
            <EmailVerificationComponent @to-step-two="navigateToVerifyOTP" v-if="step === 1"/>
            <OtpCheck :userEmail="email" @to-step-three="navigateToRenewPassword" v-if="step === 2"/>
            <PasswordResetComponent :user-email="email" @to-step-four="navigateToSuccessPage" v-if="step === 3"/>
            <ResetSuccessfullcomponent v-if="step === 4"/>
        </div>
    </AuthLayout>
</template>

<script setup>
import AuthLayout from "@/layout/AuthLayout.vue";
import EmailVerificationComponent from "@/components/auth/passwordReset/emailVerification.vue"
import { ref,computed  } from "vue";
import OtpCheck from "@/components/auth/passwordReset/otpCheck.vue";
import PasswordResetComponent from "@/components/auth/passwordReset/passwordResetCheck.vue"
import ResetSuccessfullcomponent from "@/components/auth/passwordReset/resetSuccessfull.vue"
import step1Img from "@/assets/Images/Forgot password.png";
import step2Img from "@/assets/Images/OTP receiving.png";
import step3Img from "@/assets/Images/New password.png";
import step4Img from "@/assets/Images/Password reset success.png";

const email = ref('');
const step = ref(1);

const navigateToVerifyOTP = (userEmail) => {
    email.value = userEmail;
    step.value = 2;
};
const navigateToRenewPassword = () => {
    step.value = 3;
};

const navigateToSuccessPage = () => {
    step.value = 4;
};
const currentImage = computed(() => {
    switch(step.value){
        case 1: return step1Img;
        case 2: return step2Img;
        case 3: return step3Img;
        case 4: return step4Img;
        default: return "";
    }
});
</script>

<style scoped>

</style>
